import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useClockPayload } from '../hooks/useClockPayload';
import { CITY_LIMIT } from '../constants';
import ClockViewPicker from './ClockViewPicker';

export default observer(function ClockViewFooter() {
    const { timeZones } = useClockPayload();

    return timeZones.length < CITY_LIMIT ? <ClockViewPicker /> : null;
});
